module.exports = __webpack_public_path__ + "img/left-square.8c82c461.svg";